import { render } from "./MysteriesOfTheRosary.vue?vue&type=template&id=05112eae&scoped=true"
const script = {}

import "./MysteriesOfTheRosary.vue?vue&type=style&index=0&id=05112eae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05112eae"]])

export default __exports__